import { Flex, Text, Title, DatePicker } from "@shared/primitive-components"
import { LocalDate } from "@flockcover/flock-svc-core-types"
import * as styles from "./styles"
import { EditCoverDatesAction, EditCoverDatesState } from "./reducers/editCoverDatesReducer"

export const EDIT_COVER_DATES_INVALID_DATE_MESSAGE = {
  ON_COVER: `On cover date is invalid`,
  OFF_COVER: `Off cover date is invalid`,
}

export const EDIT_COVER_DATES_DTI = {
  ADDED_IN_ERROR: `added_in_error_checkbox`,
}

interface EditCoverDatesProps {
  state: EditCoverDatesState
  dispatch: React.Dispatch<EditCoverDatesAction>
  displayAddedInErrorCheckbox: boolean
  numVehicles: number
  errors: { vrn: string; message: string }[]
}

export const EditCoverDates = ({
  state,
  dispatch,
  displayAddedInErrorCheckbox,
  numVehicles,
  errors,
}: EditCoverDatesProps) => (
  <>
    <Text css={styles.marginBottom}>
      You are editing the cover dates for {numVehicles} {numVehicles !== 1 ? `vehicles` : `vehicle`}
    </Text>
    <Flex css={styles.contentWrap}>
      <Flex css={styles.makeColumnStyle()}>
        <Title variant="headline2" tag="h2" css={styles.labelText}>
          On cover (optional)
        </Title>
        <Text css={styles.labelInstruction}>
          Select what date you would like vehicles to be added to your policy using the selector below.
        </Text>
        <DatePicker
          value={state.onCover}
          onChange={(value: LocalDate | undefined) => dispatch({ type: `setOnCover`, value })}
          onInvalidChange={(isInvalid: boolean) => dispatch({ type: `setOnCoverInvalid`, isInvalid })}
          data-testid="onCoverInput"
          variant="form"
          invalidDateMessage={EDIT_COVER_DATES_INVALID_DATE_MESSAGE.ON_COVER}
          css={styles.dateField}
          displayDateInvalid
        />
      </Flex>

      <Flex css={styles.makeColumnStyle(true)}>
        <Title variant="headline2" tag="h2" css={styles.labelText}>
          Off cover (optional)
        </Title>
        <Text css={styles.labelInstruction}>
          If this is a temporary addition to your fleet you can also choose a date for the vehicle to be removed from
          your policy automatically.
        </Text>
        <DatePicker
          value={state.offCover}
          onChange={(value: LocalDate | undefined) => dispatch({ type: `setOffCover`, value })}
          onInvalidChange={(isInvalid: boolean) => dispatch({ type: `setOffCoverInvalid`, isInvalid })}
          data-testid="offCoverInput"
          variant="form"
          invalidDateMessage={EDIT_COVER_DATES_INVALID_DATE_MESSAGE.OFF_COVER}
          css={styles.dateField}
          displayDateInvalid
        />
        {displayAddedInErrorCheckbox && (
          <Flex css={styles.checkboxContainer}>
            <>
              <br />
              <Text css={styles.labelText}>
                &nbsp; {numVehicles !== 1 ? `Vehicles` : `Vehicle`} added in error: &nbsp;
                <input
                  type="checkbox"
                  name="addedInError"
                  id="addedInError"
                  data-testid={EDIT_COVER_DATES_DTI.ADDED_IN_ERROR}
                  checked={state.addedInError}
                  onChange={() => {
                    dispatch({ type: `toggleAddedInError` })
                  }}
                />
              </Text>
            </>
          </Flex>
        )}
      </Flex>
    </Flex>
    {!!errors &&
      errors.map((error, index: number) => (
        <Text key={index} css={styles.error}>
          {error.message} ({error.vrn})
        </Text>
      ))}
  </>
)
